<template>
  <div class="py-3 flex" :class="{ 'border-b': show_border }">
    <div class="flex-grow leading-normal pr-2">
      <div v-text="title" class="text-sm font-bold"></div>
      <div v-text="description" class="text-xs text-grey-dark"></div>
    </div>
    <div>
      <SwitchControl
        @toggle="toggle"
        v-bind:checked="checked"
        v-bind:disabled="disabled"
      />
    </div>
  </div>
</template>

<script>
import SwitchControl from "./SwitchControl.vue";
import User from "./../../services/User.js";

export default {
  name: "v-switch-setting",
  components: {
    SwitchControl,
  },
  props: {
    title: {
      type: String,
    },
    description: {
      type: String,
    },
    type: {
      type: Number,
    },
    show_border: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      disabled: false,
      checked: false,
    };
  },
  mounted() {
    let store = this.$store.state;
    let config_item = store.config.find(item => item.type === this.type);
    this.checked = config_item ? config_item.status : null;
  },
  methods: {
    toggle(value) {
      let that = this,
        state = this.$store.state;

      this.disabled = true;
      this.checked = value;

      User.setConfig(state.uuid, this.type, this.checked ? 1 : 0)
        .then(function () {
          state.config = {
            type: that.type,
            status: that.checked? true : false,
          };
          that.disabled = false;
          that.$emit("success");
        })
        .catch(function (error) {
          that.disabled = false;
          that.$emit("error", error);
        });

      this.$emit("toggle", value);
    },
  },
};
</script>
